import axios from './../api' 

//授权 登录
const kunnonhallinta = (params) => {
  return axios({
    url: '/api/h5/login',
    params
  })
}
export default {
  kunnonhallinta
}